// These lives in a separate file so that they can be mocked in tests
export const ONE_TIME_CODE_TOO_MANY_REQUESTS_TIMEOUT = 10 * 1000; // 10 seconds
export const ONE_TIME_CODE_EXPIRATION_TIME = 5 * 60 * 1000; // 5 minutes
export const ONE_TIME_CODE_POLLING_INTERVAL = 3000;
